export const CLOSE_APP_NOTIFICATION = 'CLOSE_APP_NOTIFICATION' as const;
export const CLOSE_AND_CLEAR_APP_NOTIFICATION = 'CLOSE_AND_CLEAR_APP_NOTIFICATION' as const;
export const TRIGGER_APP_NOTIFICATION = 'TRIGGER_APP_NOTIFICATION' as const;

export const NOTIFICATION_LEVELS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type NotificationLevel = (typeof NOTIFICATION_LEVELS)[keyof typeof NOTIFICATION_LEVELS];

type CloseAppNotificationAction = {
  type: typeof CLOSE_APP_NOTIFICATION;
};

type CloseAndClearAppNotificationAction = {
  type: typeof CLOSE_AND_CLEAR_APP_NOTIFICATION;
};

type TriggerAppNotificationAction = {
  type: typeof TRIGGER_APP_NOTIFICATION;
  payload: {
    text: string;
    level: NotificationLevel;
  };
};

export const closeAndClearAppNotification = (): CloseAndClearAppNotificationAction => ({
  type: CLOSE_AND_CLEAR_APP_NOTIFICATION,
});

export const triggerAppNotification = ({
  text,
  level,
}: {
  text: string;
  level: NotificationLevel;
}): TriggerAppNotificationAction => ({
  type: TRIGGER_APP_NOTIFICATION,
  payload: { text, level },
});

export type AppNotificationAction =
  | CloseAppNotificationAction
  | CloseAndClearAppNotificationAction
  | TriggerAppNotificationAction;
